export const removeTransparencyFromHex = (hex) => {
    return hex.substring(0, hex.length - 2);
};
